var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"align_left"},[_vm._v(_vm._s(_vm.parcours.nom))]),_c('div',{attrs:{"id":'profilContainer-' + _vm.parcours.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }